(function ($) {
  // Form

  var photoFieldClassName = 'worst-cycling-lane__form__photo-field';

  var popupElement = $('.worst-cycling-lane__form-popup');
  var mobileButton = $('.worst-cycling-lane__mobile-add-button');
  var photoInputElement = $('input#wcl-image');
  var photoFileInputElement = $('input#wcl-temp-image');
  var photoPreviewElement = $('.worst-cycling-lane__form__photo-preview');
  var photoField = $('.' + photoFieldClassName);
  var formElement = $('form.worst-cycling-lane__form');
  var locationInput = $('input#wcl-location');
  var responseElement = $('.worst-cycling-lane__form__response');
  var errorElement = $('.worst-cycling-lane__form__error');

  var formFetchUrl = window.ys.rest_url + 'ys/worst-cycling-lane/v1/create';
  var cropper = null;

  var recaptcha = window.ys.recaptcha_key;
  var initializedRecaptcha = false;
  var recaptchaReady = false;

  var formDataReadyToSend = null;

  /**
   * Resize image for use in the cropper.js element.
   * Due to iOS limitation, we need lower resolution
   * @param {string} inputData
   */
  function resizeBase64(inputData) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        var width = 1024;
        var height = 1024;

        var ar = img.width / img.height;
        if (ar < 1) {
          height /= ar;
        } else {
          width *= ar;
        }

        canvas.width = width;
        canvas.height = height;

        context.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL());
      };

      img.src = inputData;
    });
  }

  function getBase64(file) {
    if ('loadImage' in window) {
      return loadImage(file, {
        orientation: true,
        canvas: true,
        crossOrigin: 'Anonymous',
        maxWidth: 1920,
        maxHeight: 1920,
      }).then(function (result) {
        return result.image.toDataURL('image/jpeg');
      });
    }

    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        resizeBase64(reader.result).then(function (data) {
          resolve(data);
        });
      };

      reader.onerror = function () {
        reject(reader.error);
      };
    });
  }

  function getFormData($form) {
    var unindexedArray = $form.serializeArray();
    var indexedArray = {};

    $.map(unindexedArray, function (n, i) {
      indexedArray[n.name] = n.value;
    });

    if (indexedArray['wcl-newsletter']) {
      indexedArray['wcl-newsletter'] = true;
    }

    if (
      indexedArray['wcl-name'] === '' ||
      indexedArray['wcl-name'].trim() === ''
    ) {
      delete indexedArray['wcl-name'];
    }

    if (cropper) {
      var imageInputName = photoInputElement.attr('name');
      delete indexedArray[imageInputName];
      var croppedCanvas = cropper.getCroppedCanvas();
      if (croppedCanvas !== null) {
        indexedArray[imageInputName] = croppedCanvas.toDataURL('image/jpeg');
      }
    }

    return indexedArray;
  }

  function validateRequiredStringField(value, selector) {
    var field = $('.worst-cycling-lane__form__field--' + selector);

    if (typeof value === 'undefined' || value === '') {
      field.addClass('wcl-field__invalid');
      return false;
    }

    field.removeClass('wcl-field__invalid');
    return true;
  }

  function enableFormElements() {
    $('.worst-cycling-lane__form__button--done').removeClass(
      'worst-cycling-lane__form__button--disabled'
    );
    $('.worst-cycling-lane__form__button--done').attr('disabled', false);
    $('.worst-cycling-lane__form__button--done').removeClass(
      'worst-cycling-lane__form__button--loading'
    );
  }

  function validateFormData(formData) {
    var check = true;

    var caption = 'wcl-caption';
    var email = 'wcl-email';
    var image = 'wcl-image';
    var location = 'wcl-location';
    var country = 'wcl-country';
    var nonce = 'wcl-nonce';

    if (!validateRequiredStringField(formData[caption], caption)) {
      check = false;
    }
    if (!validateRequiredStringField(formData[location], location)) {
      check = false;
    }
    if (!validateRequiredStringField(formData[country], country)) {
      check = false;
    }
    if (!validateRequiredStringField(formData[nonce], nonce)) {
      check = false;
    }
    if (!validateRequiredStringField(formData[email], email)) {
      check = false;
    }

    if (cropper) {
      // Validate that cropper is properly initialized and loaded
      var croppedCanvas = cropper.getCroppedCanvas();
      if (croppedCanvas === null) {
        validateRequiredStringField(undefined, image);
        check = false;
      }
    } else {
      if (!validateRequiredStringField(formData[image], image)) {
        check = false;
      }
    }
    return check;
  }

  function initializeCropper() {
    if ('Cropper' in window) {
      var image = document.querySelector(
        '.worst-cycling-lane__form__photo-preview'
      );
      if (image) {
        cropper = new Cropper(image, {
          aspectRatio: 1,
          autoCrop: true,
          autoCropArea: 1,
          checkOrientation: false,
          center: false,
          cropBoxMovable: false,
          cropBoxResizable: false,
          dragMode: 'move',
          initialAspectRatio: 1,
          rotatable: false,
          toggleDragModeOnDblclick: false,
          viewMode: 3,
        });
      }
    }
  }

  function addIdToBackButton(laneId) {
    var backButtonElement = $('.worst-cycling-lane__form__button--back');

    // Get the URL and remove params if present
    var url = window.location.href.split('?')[0];
    var urlAppend = '?lane-id=' + laneId;

    backButtonElement.attr('href', url + urlAppend);
  }

  /**
   * Submit form data to the backend API
   *
   * @param {string|null} token  Null token is allowed if reCaptcha is disabled
   * @returns {void}
   */
  function submitForm(token) {
    if (formDataReadyToSend === null) {
      enableFormElements();
      if (recaptcha) {
        grecaptcha.reset();
      }
      return;
    }

    if (token) {
      formDataReadyToSend.token = token;
    }

    fetch(formFetchUrl, {
      headers: {
        'content-type': 'application/json; charset=UTF-8',
      },
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(formDataReadyToSend),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        if (result.data.id) {
          window.WorstCyclingLane.UserData.AddUploadedLane(result.data.id);
          addIdToBackButton(result.data.id);
        }

        responseElement.removeClass('hidden');
        formElement
          .find('input[name=wcl-temp-image], input[name=wcl-image]')
          .val('');
        formElement.get(0).reset();
        if (cropper) {
          cropper.destroy();
        }
        photoField.removeClass(photoFieldClassName + '--has-photo');
      })
      .catch(function () {
        errorElement.removeClass('hidden');
      })
      .finally(function () {
        enableFormElements();
        if (recaptcha) {
          window.grecaptcha.reset();
        }
      });
  }

  function loadRecaptcha() {
    if (!recaptcha || initializedRecaptcha) {
      return;
    }

    initializedRecaptcha = true;

    function injectRecaptcha() {
      var $captcha = $('<div class="g-recaptcha" data-size="invisible"></div>');
      formElement.after($captcha);

      var id = grecaptcha.render($captcha.get(0), {
        sitekey: recaptcha,
        callback: submitForm,
      });

      formElement.data('widgetId', id);
      recaptchaReady = true;
    }

    if (document.recaptchaLoaded) {
      injectRecaptcha();
    } else {
      document.addEventListener('recaptchaLoaded', injectRecaptcha);
    }
  }

  $(
    '.worst-cycling-lane__add-photo, .worst-cycling-lane__mobile-add-button, .worst-cycling-lane__add-photo-header__button'
  ).click(function () {
    mobileButton.addClass('hidden');
    popupElement.addClass('active');
    loadRecaptcha();
    // Trigger change event on photo input element to load cropper js after page reload
    photoFileInputElement.trigger('change');
    $('html').addClass('worst-cycling-lane--adding-lane');
  });

  formElement.on('submit', function (e) {
    e.preventDefault();

    formDataReadyToSend = getFormData(formElement);
    if (!validateFormData(formDataReadyToSend)) {
      formDataReadyToSend = null;
      return;
    }

    responseElement.addClass('hidden');
    errorElement.addClass('hidden');
    $('.worst-cycling-lane__form__button--done').addClass(
      'worst-cycling-lane__form__button--disabled'
    );
    $('.worst-cycling-lane__form__button--done').addClass(
      'worst-cycling-lane__form__button--loading'
    );

    $('.worst-cycling-lane__form__button--done').attr('disabled', 'disabled');

    if (recaptcha) {
      if (!recaptchaReady) {
        errorElement.removeClass('hidden');
        return;
      }

      window.grecaptcha.execute(formElement.data('widgetId'));
    } else {
      submitForm(null);
    }
  });

  $(
    '.worst-cycling-lane__form__select-photo, .worst-cycling-lane__form__change-photo'
  ).click(function (e) {
    photoFileInputElement.trigger('click');
  });

  photoFileInputElement.on('change', function (e) {
    var uploadedFile = this.files[0];

    if (uploadedFile) {
      getBase64(uploadedFile).then(function (fileB64) {
        photoInputElement.val(fileB64);
        if (cropper) {
          cropper.destroy();
        }
        photoField.addClass(photoFieldClassName + '--has-photo');
        $('.worst-cycling-lane__form__field--wcl-image').removeClass(
          'wcl-field__invalid'
        );

        // Get temp URL of uploaded file & show it on front-end
        photoPreviewElement.attr('src', URL.createObjectURL(uploadedFile));

        initializeCropper();
      });
    }
  });

  /**
   * Removes error flag from form fields
   * @param {Event} e
   */
  function removeErrorMessageFromParentField(e) {
    if (!e.currentTarget) {
      return;
    }

    var parent = e.currentTarget.closest('.worst-cycling-lane__form__field');
    if (!parent) {
      return;
    }

    parent.classList.remove('wcl-field__invalid');
  }

  $('.worst-cycling-lane__form__field input').on(
    'input',
    removeErrorMessageFromParentField
  );
  $('.worst-cycling-lane__form__field select').on(
    'change',
    removeErrorMessageFromParentField
  );

  $(document).ready(function () {
    window.WorstCyclingLane.Location.BindLocation(locationInput.get(0));
  });
})(jQuery);
